<template>
  <ul class="avatars">
    <li class="avatar-item" v-for="item in people" :key="item.name">
      <Avatar v-bind="item" />
    </li>
  </ul>
</template>

<script>
import Avatar from '@/components/avatar';

export default {
  components: { Avatar },
  computed: {
    people() {
      return [
        {
          name: 'Anna Jaffe',
          title: 'Impact',
          image: '/img/contact-anna.jpg',
        },
        {
          name: 'Peng Yu',
          title: 'Technology',
          image: '/img/contact-peng.jpg',
        },
        {
          name: 'Lorea Sinclaire',
          title: 'Design',
          image: '/img/contact-lorea.jpg',
        },
        {
          name: 'Murtagh Hunt',
          title: 'Operations',
          image: '/img/contact-murtagh.jpg',
        },
        {
          name: 'Brian Williams',
          title: 'MIT MERS',
          image: '/img/contact-brian.jpg',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar /deep/ .avatar-title {
  color: var(--white-transparent);
}

.avatars {
  column-gap: 24px;
  display: grid;
  grid-template-columns: 1fr;
  list-style: none;
  margin: 24px 0 48px;
  padding: 0;
  row-gap: 20px;

  @media screen and (min-width: 450px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
